export default "__VITE_ASSET__ce631eee__"